module.exports = __webpack_public_path__ + "img/code.f0b9da2e.png";